/* Homepage scroll-reveal (Jul 2026 redesign layer).
   Tags section headings and card grids on the homepage, then reveals them once
   as they enter the viewport. CSS handles the motion (redesign.css) and the
   prefers-reduced-motion gate, so with reduced motion this script is inert. */
(function () {
  var TEMPLATES = ['tpl-index', 'tpl-product', 'tpl-collection', 'tpl-page', 'tpl-blog', 'tpl-list-collections'];
  var ok = TEMPLATES.some(function (t) { return document.body.classList.contains(t); });
  if (!ok) return;
  if (!('IntersectionObserver' in window)) return;

  var HEADS = [
    '.notg-selector__head',
    '.hiw__head',
    '.notg-ugc__head',
    '.notg-audience__head',
    '.notg-revhl__head',
    '.notg-ladder__head',
    '.notg-ingredients__head',
    '.notg-founder__body',
    '.notg-faq__heading',
    '.coll__head',
    '.pcc__head',
    '.ccc__head',
    '.tpc__head',
    '.ftl__head',
    '.fyf__head',
    '.notg-contact__head',
    '.pcm__head',
    '.poc__head',
    '.ab__values',
    '.ab__cta-heading'
  ].join(', ');

  /* Buy boxes and purchase UI are never tagged (no CLS on the money path).
     Cards inside horizontal scrollers (review carousel, UGC track) are also
     never tagged individually: revealing mid-swipe reads as broken dragging.
     Their whole container reveals once instead. */
  var CARDS =
    '.hiw__step, .notg-ladder__card, .notg-ingredients__card, ' +
    '.notg-audience__card, .ab__value, .ab__stat, .blog-card, ' +
    '.notg-revhl__carousel, .notg-ugc__track';

  function tag(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      var siblings = el.parentElement ? el.parentElement.children : [];
      var i = Array.prototype.indexOf.call(siblings, el);
      el.style.setProperty('--reveal-i', String(Math.max(0, i % 8)));
    });
  }

  tag(HEADS);
  tag(CARDS);

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
  );

  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    io.observe(el);
  });

  /* Safety net: observing <body> must call back immediately. If it hasn't
     within 1.5s the observer is stalled (odd embed/webview), so reveal
     everything rather than leave content hidden. */
  var ioAlive = false;
  var probe = new IntersectionObserver(function () {
    ioAlive = true;
    probe.disconnect();
  });
  probe.observe(document.body);
  setTimeout(function () {
    if (ioAlive) return;
    io.disconnect();
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }, 1500);
})();
